import React from "react";
import Bubble from "../../icons/Bubble.svg";
import HighPrio from "./HighPrio/HighPrio";
import MidPrio from "./MidPrio/MidPrio";
import LowPrio from "./LowPrio/LowPrio";

const ToDoListCard = () => {
  return (
    <div className="w-full h-full bg-white rounded-2xl shadow-sm">
      <div className="p-4 flex flex-col h-full">
        {/* Header with Bubble Icon */}
        <div className="w-14 h-12 relative mb-4">
          <img
            src={Bubble}
            alt="To-Do Icon"
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>

        {/* Sections */}
        <HighPrio />
        <MidPrio />
        <LowPrio />
      </div>
    </div>
  );
};

export default ToDoListCard;
